import { h } from 'preact';
import { Range } from "react-range";


const SliderInput = ({amount, disabled, changeFunc, label, style, variableKey}) => {

  const changeThis = changeFunc(variableKey);

  if (disabled) {
    return;
  }

  return (
    <>
      <label for={variableKey}>{label}</label>
      <Range
        name={variableKey}
        step={0.05}
        min={0}
        max={1}
        disabled={disabled}
        values={[amount]}
        onChange={changeThis}
        renderTrack={({ props, children }) => (
          <div
            className={style.rangeInput}
            {...props}
            style={{
              ...props.style,
              height: '6px',
              width: '100%',
              backgroundColor: '#ccc'
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className={style.thumb}
          />
        )}
      />
    </>
  )
}

export default SliderInput;